import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { WebsiteIndex, WebIngestionDto, IngestionResponse } from '../shared/interfaces';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class WebService {
  private readonly http = inject(HttpClient);  
  private readonly apiUrl = environment.apiUrl;
  private readonly controller = 'web-ingestion'

  /**
   * Recupera l'alberatura JSON completa: Indici -> Siti -> Pagine
   */
  getWebsites(): Observable<WebsiteIndex[]> {
    return this.http.get<WebsiteIndex[]>(`${this.apiUrl}/${this.controller}/sites`);
  }
  
  crawlWebsite(payload: WebIngestionDto): Observable<IngestionResponse> {
      return this.http.post<IngestionResponse>(`${this.apiUrl}/${this.controller}/crawl`, payload);
    }
}